import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-family: ${theme.font.comfortaa};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    margin: 14px 8px -72px 90px;
    width: 100%;
    max-width: 1084px;

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 460px;
    `}

    ${media.lessThan('small')`
      max-width: 270px;
    `}
  `}
`

export const CardContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: relative;
    max-width: 1084px;
    height: auto;
    margin: 82px 8px 40px 90px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    ${media.lessThan('small')`
      max-width: 300px;
    `}
  `}
`

export const ActionsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-top: 50px;
    margin-bottom: 20px;
    padding: 0 24px;

    > button {
      max-width: 328px;
      position: relative;

      > svg {
        position: absolute;
        left: 16px;
        top: 14px;

        > path {
          fill: ${theme.colors.white};
        }
      }
    }

    ${media.lessThan('medium')`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      > button {
        max-width: 100%;
        margin: 0px 20px;
      }

      > div {
        margin: 18px 20px 0 20px;
      }
    `}

    ${media.lessThan('small')`
      > button svg {
        display: none;
      }
    `}
  `}
`

export const TableContainer = styled.div`
  padding: 24px;

  ${media.lessThan('medium')`
    padding: 24px 50px;
  `}
`

export const ModalInfo = styled.div`
  > button {
    margin-top: 28px;
  }
`

export const ButtonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin-bottom: 80px;
    margin-left: 32px;
    gap: 6px;
    width: 60%;

    > p {
      position: absolute;
      right: 36px;
      bottom: 80px;
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.normal};
      font-weight: ${theme.font.semiBold};
    }

    .button-save {
      max-width: 180px;
      position: relative;

      > svg {
        position: absolute;
        left: 20px;
      }
    }

    .button-return-to-list {
      max-width: 256px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;

      > a {
        text-align: center;
        text-decoration: none;
        width: 100%;
        padding: 0.8rem;
        border-radius: ${theme.border.radius};
        color: ${theme.colors.darkGray};
      }

      > svg {
        position: absolute;
        left: 10px;
      }
    }

    ${media.lessThan('medium')`
      width: 90%;
      justify-content: space-between;

      p{
        display: none;
      }

      .button-return-to-list {
        svg {
          display: none;
        }
      }

      .button-printer {
        svg {
          display: none;
        }
      }

      .button-save {
        svg {
          display: none;
        }
      }
    `}

    ${media.lessThan('small')`
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 8px;

      .button-save{
        margin-bottom: 20px;

        svg {
          display: flex;
        }
      }

      .button-printer {
        svg {
          display: flex;
        }
      }

      .button-return-to-list{
        max-width: 200px;
        text-align: center;

        svg {
          display: flex;
        }
      }
    `}
  `}
`

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 15px;
  z-index: 1;

  > button {
    width: 528px;
    border: 0;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.45);
  }

  ${media.lessThan('small')`
    right: 65px;
    > button {
      width: 208px;
    }
  `}
`
